<template>
  <v-footer
    v-if="$vuetify.breakpoint.mdAndUp"
    ref="pageFooter"
    :absolute="!$route.meta.fixedFooter && !inner"
    :style="{backgroundColor: dark ? $finColors.primaryDark : ' ', borderTop: dark ? '' : '1px solid grey', left: inner ? 0 : $valueByBreakpoint($finSideNav.width), width: 'auto'}"
    :app="!inner"
    min-height="55">

    <v-row
      :class="dark ? 'mx-12 my-2' : 'mx-5'"
      justify="center"
    >
      <span :class="(dark ? 'fin-color-primary-light--text footer-copyright-dark' : '') + ' footer-copyright my-2'"
            v-html="copyright"/>
      <v-spacer/>
      <template v-for="(item, index) in routes">
        <v-btn :id="item.cssID"
               :key="index"
               :color="dark ? '' : 'fin-color-primary-dark'"
               :dark="dark"
               :to="item.to"
               class="footer-button mx-1"
               link
               text
        >
          {{ item.name }}
        </v-btn>
      </template>
      <v-btn v-if="!isApp"
             id="cookiebot"
             :color="dark ? '' : 'fin-color-primary-dark'"
             :dark="dark"
             class="footer-button mx-1"
             link
             text
             @click="openCookieBotBanner">
        Privacy Einstellungen
      </v-btn>
    </v-row>
    <v-row v-if="!isProtectedPage" dense>
      <v-col align="center">
        <p class="fin-color-primary-light--text" style="font-size: 14px;max-width: 85%;">{{ baFinHint }}</p>
      </v-col>
    </v-row>
  </v-footer>

  <v-footer
    v-else
    ref="pageFooter"
    :absolute="!$route.meta.fixedFooter && !inner"
    :style="{backgroundColor: dark ? $finColors.primaryDark : ' ', borderTop: dark ? '' : '1px solid grey', left: inner ? 0 : $valueByBreakpoint($finSideNav.width), width: 'auto'}"
    class="px-3 py-1"
    :app="!inner">
    <v-row
      justify="center"
      no-gutters>
      <template v-for="(item, index) in routes">
        <v-btn
          :key="index"
          :color="dark ? '' : 'fin-color-primary-dark'"
          :dark="dark"
          :to="item.to"
          class="footer-button-small mb-1 mx-1"
          link
          x-small
          text
        >
          {{ item.name }}
        </v-btn>
      </template>
      <v-col
        :class="(dark ? 'white--text' : ' ') + ' text-center'"
        cols="12">
          <span
            :class="(dark ? 'footer-copyright-dark fin-color-primary-light--text' : '') + ' footer-copyright-small my-2'"
            v-html="copyright"/>
      </v-col>
    </v-row>
    <v-row v-if="!isProtectedPage" dense>
      <v-col>
        <p class="fin-color-primary-light--text" style="font-size: 14px;">{{ baFinHint }}</p>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import {COPYRIGHT} from '@/js/finConstants'
import finBrowser from "@/js/finBrowser"

export default {
  name: 'fin-footer',
  props: {
    routes: {
      type: Array
    },
    dark: {
      type: Boolean,
      default: false
    },
    inner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isApp: finBrowser.IS_IOS_OR_ANDROID_APP,
      copyright: COPYRIGHT,
      baFinHint: "Die finCraft AG ist im Rahmen der Anlageberatung und Anlagevermittlung von Finanzinstrumenten gem. §2 Abs. 2 Nr. 3,4 WpIG ausschließlich für Rechnung und unter der Haftung der BfV Bank für Vermögen AG tätig. Abweichend hiervon findet die Erstellung des Anlagevorschlages nicht unter dem Haftungsdach der BfV AG statt wenn der Anwender/Kunde auf die Nutzung seines von finCraft erhobenen Archetypen (Investorprofil) als Ausgangsbasis seines Investmentprozesses verzichtet."
    }
  },
  computed: {
    isProtectedPage() {
      return this.$route.fullPath.startsWith("/protected/")
    }
  },
  methods: {
    openCookieBotBanner() {
      window.Cookiebot.renew()
    }
  }
}
</script>

<style scoped lang="scss">
.footer-button, .footer-copyright, .footer-button-small, .footer-copyright-small {
  font-weight: bold;
}

.footer-copyright-dark {
  opacity: 0.6;
}

.footer-copyright-small {
  font-size: 13px;
}

.footer-button-small {
  font-size: 14px;
}
</style>
